<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Factor 1 Value</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <!-- v-if="this.data.rtnLimKey1 === ('CSVA' || 'CSTA')" -->
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.val }}</td>
                  <td class="text-xs-left">{{ row.item.valDesc }}</td>
                  <td class="text-right">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      search: '',
      headersInter: [{ text: 'Intermediary', value: 'val' }, { text: 'Intermediary Description', value: 'valDesc' }, TableConst.tableActionHeader],
      headersCrgoComdty: [{ text: 'Commodity', value: 'val' }, { text: 'Commodity Description', value: 'valDesc' }, TableConst.tableActionHeader],
      headersCrgoPack: [{ text: 'Packing', value: 'val' }, { text: 'Description', value: 'valDesc' }, TableConst.tableActionHeader],
      headersFireConstrnCls: [{ text: 'Construstion Class', value: 'val' }, { text: 'Description', value: 'valDesc' }, TableConst.tableActionHeader],
      headersFireDistrictCls: [{ text: 'District Class', value: 'val' }, { text: 'Description', value: 'valDesc' }, TableConst.tableActionHeader],
      headersFireOccupancy: [
        { text: 'Fire Occupation Class', value: 'val' },
        { text: 'Description', value: 'valDesc' },
        TableConst.tableActionHeader
      ],
      headersFireOccpnClsLim: [
        { text: 'Fire Occupation Class Limit', value: 'val' },
        { text: 'Description', value: 'valDesc' },
        TableConst.tableActionHeader
      ],
      headersInsured: [{ text: 'Insured', value: 'val' }, { text: 'Name', value: 'valDesc' }, TableConst.tableActionHeader],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
    this.checkHeaders()
  },
  methods: {
    async doInit() {
      const apiUrl = this.menu.getFacValList
      const requestParams = {
        facVal: this.data.rtnLimKey1
      }

      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          this.items = []
          const { data } = result.data
          //  && this.data.rtnLimKey1 === ('CSVA' || 'CSTA')
          if (this.data.rtnLimKey1 === 'FOCC') {
            if (data) {
              data.map((facVal) => {
                const convertList = {
                  val: facVal.occpnCls,
                  valDesc: facVal.occpnClsDesc
                }
                this.items.push(convertList)
              })
            }
          } else {
            if (data) {
              data.map((facVal) => {
                const convertList = {
                  val: facVal.val,
                  valDesc: facVal.valDesc
                }
                this.items.push(convertList)
              })
            }
          }
          // else if (data && this.data.rtnLimKey1 === 'CCOM') {

          // }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    checkHeaders() {
      if (this.data.rtnLimKey1 === 'CSVA' || this.data.rtnLimKey1 === 'CSTA') {
        this.headers = this.headersInter
      } else if (this.data.rtnLimKey1 === 'CCOM') {
        this.headers = this.headersCrgoComdty
      } else if (this.data.rtnLimKey1 === 'CPKG') {
        this.headers = this.headersCrgoPack
      } else if (this.data.rtnLimKey1 === 'FCON') {
        this.headers = this.headersFireConstrnCls
      } else if (this.data.rtnLimKey1 === 'FDIS') {
        this.headers = this.headersFireDistrictCls
      } else if (this.data.rtnLimKey1 === 'FOCC') {
        this.headers = this.headersFireOccupancy
      } else if (this.data.rtnLimKey1 === 'FOCL') {
        this.headers = this.headersFireOccpnClsLim
      } else if (this.data.rtnLimKey1 === 'INS') {
        this.headers = this.headersInsured
      }
    },
    doSelect(data) {
      const facVal = {
        facVal: data.val,
        facValDesc: data.valDesc
      }
      this.$emit('fac1Val', facVal)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.rtnLimParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: ['data']
}
</script>
